// constant.ts
export const API_URL = "https://x7dj7hh5-5577.inc1.devtunnels.ms/api/"; // live
// export const API_URL = "http://82.29.165.216:3211/SHRMS/api/v1"; // local

export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || "/";

export const API_ENDPOINT = {
  // auth
  auth: "auth/login",
  profile: "auth/profile",
  changePassword: "auth/change-password",
  logout: "auth/logout",

  // site
  createSite: "site/create",
  siteList: "site/list",
  siteDetail: "site/detail/:id",
  siteUpdate: "site/update/:id",
  siteDelete: "site/delete/:id",

  // shift
  createShift: "admin/shift/create",
  shiftList: "admin/shift/list",
  shiftUpdate: "admin/shift/update/:id",
  shiftDetail: "admin/shift/detail/:id",
  shifDelete: "admin/shift/delete/:id",

  // notification
  notification: "",

  // worker
  createWorker: "worker/create",
  workerList: "worker/list",
  workerDetail: "worker/detail/:workerId",
  workerUpdate: "worker/update/:workerId",
  workerDelete: "worker/delete/:workerId",
  workerBulkTemplate: "worker/template/download",
  workerBulkUpload: "worker/bulk-upload",

  // attendance

  createAttendance: "attendance/create",
  biometricSyncAttendance: "attendance/biometric-sync",
  attendanceList: "attendance/list",
  attendanceMatrix: "attendance/matrix",
  attendanceDetail: "attendance/detail/:attendanceId",
  attendanceUpdate: "attendance/update/:attendanceId",
  attendanceDelete: "attendance/delete/:attendanceId",
};